import styled from '@emotion/styled';
import Typography from '@material-ui/core/Typography';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { PerformanceReport, PeriodicDetailPerformanceWithAllFieldsFragment } from '../../../../generated/graphql';
import { SPACING_LARGE, SPACING_REGULAR, SPACING_UNIT } from '../../../constant/spacing';
import { flexibleLayoutContainer } from '../../../styleUtility/flexibleLayout';
import Spinner from '../Spinner';
import DetailPerformance from './DetailPerformance';
// @ts-ignore
import DetailPerformanceExporter from './DetailPerformanceExporter';
import EmptyState from './EmptyState';

type Props = {
  report: PerformanceReport;
  periodicDetailPerformance: PeriodicDetailPerformanceWithAllFieldsFragment | null;
  periodicDetailPerformanceFetching: boolean;
  onClickExportButton: () => void;
  className?: string;
};

const DetailPerformanceSection: FC<Props> = ({
  report,
  periodicDetailPerformanceFetching,
  periodicDetailPerformance,
  // @ts-ignore
  onClickExportButton,
  className,
}) => {
  if (periodicDetailPerformanceFetching) {
    return <Spinner />;
  }

  return (
    <Root className={className}>
      <Heading variant="h6" color="textSecondary">
        <FormattedMessage id="performance_report_headline.performance_detail" />
      </Heading>

      {/*<ButtonWrapper>*/}
      {/*  <DetailPerformanceExporter onClickExportButton={onClickExportButton} />*/}
      {/*</ButtonWrapper>*/}

      {periodicDetailPerformance && periodicDetailPerformance.creatives.length >= 1 ? (
        <DetailPerformance report={report} periodicPerformance={periodicDetailPerformance} />
      ) : (
        <EmptyState />
      )}
    </Root>
  );
};

const Root = styled('div')({
  marginBottom: SPACING_LARGE,
});

const Heading = styled(Typography)({
  marginBottom: SPACING_REGULAR,
});

// @ts-ignore
const ButtonWrapper = styled('div')({
  ...flexibleLayoutContainer({
    justifyContent: 'flex-end',
  }),
  padding: `${SPACING_UNIT}px 0`,
});

export default DetailPerformanceSection;
